/*
 * treatment (schema)
 */
import { boolean, integer, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"
import { patients } from "../patient/patient.schema"
import { treatmentPlans } from "../treatment-plan/treatment-plan.schema"

export const treatments = schema.table("treatments", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	treatmentPlanId: uuid("treatment_plan_id")
		.notNull()
		.references(() => treatmentPlans.id, { onDelete: "cascade" }),
	patientId: uuid("patient_id")
		.notNull()
		.references(() => patients.id, { onDelete: "cascade" }),

	// --- General ---
	timePeriodId: integer("time_period_id").notNull(), // 1=Morning 2=Midday 3=Evening 4=Night 5=As Needed
	dosingGuidelines: text("dosing_guidelines"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
